'use client';

import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY_INITIALS } from '@/shared/constants/query-key-initials';
import { fetchPlans } from '@/shared/services/payment';
import { ISFetchPlansResponse } from '@/shared/services/payment/payment.types';

const TEN_MINUTES_MS = 10 * 60 * 1000;

export function usePricingPlans() {
	const res = useQuery<ISFetchPlansResponse>({
		queryKey: [QUERY_KEY_INITIALS.PRICING_PLANS],
		queryFn: fetchPlans,
		staleTime: TEN_MINUTES_MS,
	});

	return res;
}
